import * as R from 'ramda'

export const limitTo = R.curry(
  (n, array) => {
    let i = n
    return R.takeWhile(() => {
      i--
      return i > -1
    }, array)
  }
)
